import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import SEO from 'components/SEO'
import StickyNavigation from 'components/StickyNavigation'
import TestimonialSlider from 'components/TestimonialSlider'
import LogoSection from 'components/Index/Footer/LogoSection'
import Footer from 'components/Footer'

import { THEME_WHITE } from 'theme/constants'
import 'styles/main.scss'

const LayoutServices = ({ children, metaTitle, metaDescription, metaUrl }) => {
  return (
    <main className={cx('main', 'services__main')}>
      <SEO title={metaTitle} description={metaDescription}>
        <link rel="canonical" href={metaUrl} />
      </SEO>
      {children}
      <section className="services__section --no-padding --white">
        <TestimonialSlider theme={THEME_WHITE} />
      </section>
      <section className="services__section --white">
        <div className="services__paragraphs">
          <h3>Businesses we have built</h3>
        </div>
        <div className="services__logos">
          <LogoSection />
        </div>
      </section>
      <Footer hasSocial />
      <StickyNavigation theme={THEME_WHITE} />
    </main>
  )
}

LayoutServices.propTypes = {
  children: PropTypes.node,
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
  metaUrl: PropTypes.string,
}

export default LayoutServices
